(ns iris.common
  (:require
   [re-frame.core :as re-frame]
   [reagent.core :as reagent]
  ;;  [herb.core :refer [<class <id]]
   [cemerick.url :as cemerick.url]
   [iris.auth.api :as auth]
   [iris.data.api :as data]
   [iris.utils :as utils]
   [iris.events :as events]
   [iris.subs :as subs]
   [iris.routes :as routes]
   [iris.globals :as globals]
   [iris.styles.search :as $search]
   [iris.styles.message-bar :as $message-bar]
   [iris.posts.views.thread-alert :refer [thread-alert]]
   [iris.login.events :as login-events]
   [iris.posts.subs :as posts-subs]
   [iris.dev.subs :as dev-subs] ;; TODO: perhaps move this to subs
   [clojure.string :as str]
   [iris.styles.settings :as $settings]
   [iris.components.simple-modal :refer [simple-modal]]
   [iris.posts.views.text-resizer :refer [text-resizer]]
   [iris.localstorage :as localstorage]
   ))



(defn spinner []
  (let [loading @(re-frame/subscribe [::subs/loading])]
    (when (true? loading)
      [:div.spinloader])))


(defn fb-auth-state-bar []
  (let [fb-auth-state @(re-frame/subscribe [::subs/fb-auth-state])]
    (println "fb-auth-state sub:" fb-auth-state)
    (cond
      (and (true? fb-auth-state) (true? (login-events/logged-in?)))
      (println "user logged in, fb auth state true")
      (and (false? fb-auth-state) (true? (login-events/logged-in?)))
      [:div {:class
             ;;  (<class $message-bar/fb-auth-state-bar)
             $message-bar/$fb-auth-state-bar}
       [:span "You are signed out of Firebase. "]
       [:button {:class "btn btn-primary"
                 :on-click (fn [e] (auth/init-auth! @globals/fbjwt))}
        "Sign In"]]
      (and (false? fb-auth-state) (not (login-events/logged-in?))) ;; this will never be seen most likely
      [:div {:class
             ;;  (<class $message-bar/fb-auth-state-bar)
             $message-bar/$fb-auth-state-bar}
       "You are logged out of Iris, you need to log back in."])))



(defn classify-msg [m]
  "Returns the first key/value from the map that isn't :ts"
  (first (seq (dissoc m :ts))))


(def key-color
  {:info "dodgerblue"
   :result        "green"
   :error         "firebrick"
   :debug-message "firebrick"})

(def key-icon 
  {
  ;;  :info [:svg {:width 14 :height 14 :viewBox "0 0 14 14" :xmlns "http://www.w3.org/2000/svg"
  ;;               :style {:display "inline"}}
  ;;         [:circle {:cx 7 :cy 7 :r 7 :fill "#1e90ff"}]
  ;;         [:text {:x "50%" :y "50%"
  ;;                 :text-anchor "middle"
  ;;                 :dominant-baseline "central"
  ;;                 :font-size "12"
  ;;                 :font-weight "bold"
  ;;                 :fill "white"
  ;;                 :font-family "sans-serif"}
  ;;          "i"]]
   
   :info [:svg {:width 14 :height 14 :viewBox "0 0 14 14" :xmlns "http://www.w3.org/2000/svg"
                :style {:display "inline"}}
          [:circle {:cx 7 :cy 7 :r 7 :fill "#1e90ff"}]
          [:path {:d "M4 7.5L6 9.5L10 5.5"
                  :stroke "white"
                  :stroke-width "1.5"
                  :fill "none"
                  :stroke-linecap "round"
                  :stroke-linejoin "round"}]]

   :result [:svg {:width 14 :height 14 :viewBox "0 0 14 14" :xmlns "http://www.w3.org/2000/svg"
                  :style {:display "inline"}}
            [:circle {:cx 7 :cy 7 :r 7 :fill "#28a745"}]
            [:path {:d "M4 7.5L6 9.5L10 5.5"
                    :stroke "white"
                    :stroke-width "1.5"
                    :fill "none"
                    :stroke-linecap "round"
                    :stroke-linejoin "round"}]]
   :error [:svg {:width 14 :height 14 :viewBox "0 0 14 14" :xmlns "http://www.w3.org/2000/svg"
                 :style {:display "inline"}}
           [:circle {:cx 7 :cy 7 :r 7 :fill "#dc3545"}] ; Bootstrap "danger" red
           [:text {:x "50%" :y "50%"
                   :text-anchor "middle"
                   :dominant-baseline "central"
                   :font-size  "12"
                   :font-weight "bold"
                   :fill "white"
                   :font-family "sans-serif"}
            "!"]]

   :debug-message [:svg {:width 14 :height 14 :viewBox "0 0 14 14" :xmlns "http://www.w3.org/2000/svg"
                         :style {:display "inline"}}
                   [:circle {:cx 7 :cy 7 :r 7 :fill "#000000"}] ; black
                   [:text {:x "50%" :y "50%"
                           :text-anchor "middle"
                           :dominant-baseline "central"
                           :font-size  "12"
                           :font-weight "bold"
                           :fill "white"
                           :font-family "sans-serif"}
                    "!"]]})


(defn reagent-component? [x]
  (and (vector? x)
       (let [tag (first x)]
         (or (keyword? tag)         ; [:div ...]
             (fn? tag)              ; [my-component ...]
             (symbol? tag)))))      ; [some.ns/component ...] if passed unevaluated



(defn message [message-sub & options]
  (let [mode       @(re-frame/subscribe [::subs/message-bar-mode])
        index      @(re-frame/subscribe [::subs/message-bar-index])
        more-msgs  @(re-frame/subscribe [::subs/message-bar-more-msgs])
        expanded?  @(re-frame/subscribe [::subs/message-bar-expanded?])
        messages   @(re-frame/subscribe [::subs/messages :all])
        viewport-size @(re-frame/subscribe [::subs/viewport-size])
        msg-count  (count messages)
        capped-index (min (max 0 index) (dec msg-count))
        current-msg (case mode
                      :all messages
                      :at  (nth messages capped-index nil)
                      :latest (first messages))
        bar-height (cond
                     (and (= mode :all) expanded?) "calc(100dvh - 150px)"
                     :else "50px")
        personal-moderator-logs (contains? (first options) :personal-moderator-logs)]

    (when-not (or (empty? messages) (empty? current-msg))
      [:div#message-bar
       {:style {:position     "fixed"
                :bottom       0
                :left         0
                :right        0
                :height       bar-height
                :border-top "1px solid black"
                :color "black"
                :background "rgb(211, 211, 211)"
                :padding      "0.5em"
                :overflow-y   "visible"
                :z-index      9999
                :transition   "height 0.3s ease"}}

       ;; Controls, includes prev|next|expand
       ;;  [:div.controls
       ;;   {:style {:display       "flex"
       ;;            :align-items   "center"
       ;;            :gap           "0.75em"
       ;;            :position      "absolute"
       ;;            :top           "-30px"
       ;;            :left          "0"
       ;;            :background "rgb(211, 211, 211)"
       ;;            :padding "0 5px"
       ;;            :border-top "1px solid black"
       ;;            :border-right "1px solid black"
       ;;            :border-radius "0px 5px 0px 0px"
       ;;            :margin-bottom (when (or (= mode :at) (= mode :all)) "0.5em")}}



       ;;   ;; Expand Toggle
       ;;   [:button {:on-click #(do
       ;;                          (re-frame/dispatch [::events/message-bar-set-mode (if expanded? :latest :all)])
       ;;                          (re-frame/dispatch [::events/message-bar-toggle-expanded?]))
       ;;             :style {:font-size "1.5em"}}
       ;;    (if expanded? "🔽" "🔼")]

       ;;   ;; Navigation (when not :all)
       ;;   (when (and (not= mode :all) (seq messages) (>= (:x viewport-size) 768))
       ;;     [:<>

       ;;      [:button {:on-click #(do
       ;;                             (re-frame/dispatch [::events/message-bar-set-mode :at])
       ;;                             (re-frame/dispatch [::events/message-bar-set-index (dec msg-count)]))
       ;;                :style {:font-size "1.5em"}
       ;;                :disabled (= index (dec msg-count))} "⏮"]

       ;;      [:button {:on-click #(do
       ;;                             (re-frame/dispatch [::events/message-bar-set-mode :at])
       ;;                             (re-frame/dispatch [::events/message-bar-set-index (min (dec msg-count) (inc index))]))
       ;;                :style {:font-size "1.5em"}
       ;;                :disabled (= index (dec msg-count))} "◀"]


       ;;      [:span {:style {:font-size "1em"}}
       ;;       ;; (str index " / " (max 0 (dec msg-count)))
       ;;       (str (inc index) " / " (max 0 msg-count))]


       ;;      [:button {:on-click #(do
       ;;                             (re-frame/dispatch [::events/message-bar-set-mode :at])
       ;;                             (re-frame/dispatch [::events/message-bar-set-index (max 0 (dec index))]))
       ;;                :style {:font-size "1.5em"}
       ;;                :disabled (= index 0)} "▶"]

       ;;      [:button {:on-click #(do
       ;;                             (re-frame/dispatch [::events/message-bar-set-mode :at])
       ;;                             (re-frame/dispatch [::events/message-bar-set-index 0]))
       ;;                :style {:font-size "1.5em"}
       ;;                :disabled (= index 0)} "⏭"]])]







       ;;  Controls, includes expand only btn with inline-flex when not expanded!
       [:div.controls
        (if expanded? {:style {:display       "flex"
                               :align-items   "center"
                               :gap           "0.75em"
                               :position      "absolute"
                               :top           "-30px"
                               :left          "0"
                               :background "rgb(211, 211, 211)"
                               :padding "0 5px"
                               :border-top "1px solid black"
                               :border-right "1px solid black"
                               :border-radius "0px 5px 0px 0px"
                               :margin-bottom (when (or (= mode :at) (= mode :all)) "0.5em")}}
            {:style {:display "inline-flex"}})
        ;; Expand Toggle
        [:button {:on-click #(do
                               (re-frame/dispatch [::events/message-bar-set-mode (if expanded? :latest :all)])
                               (re-frame/dispatch [::events/message-bar-toggle-expanded?]))
                  :style {:font-size "1.5em"}}
         (if expanded? "🔽" "🔼")]]





       ;; Message Content
       [:div.messages
        {:style {;;  :display "flex"
                 :display "inline-flex"
                 :height "100%"
                 ;;  :align-items "center"
                 :overflow-y   "auto"
                ;;  :max-width (if expanded? "100vw" "calc(100vw - 70px)")
                 

                 :scrollbar-width "thin"
                 ;;  :margin-left "5px"
                ;;  :margin-left (if expanded? "10px" "0")
                 :vertical-align "top" ;; eliminate weird vertical offset when trying to align next to ^ btn
                 :max-width (if expanded? "100vw" "calc(100vw - 90px)")
                 :margin-left "7px"
                 }}
        (cond
          ;; single message
          (or (= mode :latest) (= mode :at))
          (do
            (println "mode here:" mode)
            (let [[k v]
                  (when (map? current-msg) (classify-msg current-msg))]
              (println "k v" k v)
              [:div {:style {:font-size "1em"
                             :align-self "center"
                             :max-height "100%"}}
               [:span {:style {;;  :font-weight "bold"
                               ;;  :color (get key-color k "white")
                               ;;  :margin-right "0.5em"
                               ;;  :margin "0 0.25em"
                               :margin-right "0.25em"}}
                ;; (name k) ":"
                ;; "►"
                ;; (subs (name k) 0 1) ":"
                (get key-icon k)]

               (if (reagent-component? v)
                 v
                 [:span {:dangerouslySetInnerHTML
                         (reagent/unsafe-html v)}])
               (when (and (pos? more-msgs) (= index 0))
                 [:span (str " [+" more-msgs " more]")])]))

          ;; all messages
          (and (= mode :all) (seq current-msg))
          [:div
           [:p {:style {
                        ;; :margin 0
                        ;; :padding-left "1em"
                        :font-weight "bold"
                        :color "darkslategray"
                        ;; :margin-bottom "10px"
                        :margin " 5px 0 10px"
                        }}
            (str "Latest " globals/MESSAGES_LIMIT " messages in reverse chronological order:")]
           (into [:ul {:style {:margin 0
                               ;;  :padding-left "1em"
                               }}]
                 (for [[i m] (map-indexed vector current-msg)
                       :let [[k v] (classify-msg m)]]
                   [:li {:key i
                         :style {:margin-bottom "0.25em"}}
                    [:span {:style {
                                    ;; :font-weight "bold"
                                    ;; :color (get key-color k "white")
                                    ;; :margin-right "0.5em"
                                    ;; :margin "0 0.25em"
                                    :margin-right "0.25em"
                                    }}
                     ;;  (name k) ":"
                     ;;  "►"
                    ;;  (subs (name k) 0 1) ":"
                     
                     (get key-icon k)
                     ]
                    (if (reagent-component? v)
                      v
                      [:span {:dangerouslySetInnerHTML
                              (reagent/unsafe-html v)}])]))]

          ;; fallback
          :else
          [:div "No messages."])]



       (when (and (true? personal-moderator-logs) (not expanded?))
         [:button {:title "Post action logs"
                   :class $message-bar/$message-bar-logs-btn
                   :on-click (fn [e] (re-frame/dispatch [::events/toggle-show-moderator-logs]))}
          (comment "?xml version=\"1.0\" encoding=\"UTF-8\"?")
          [:svg
           {:xmlns "http://www.w3.org/2000/svg"
            :xmlns:xlink "http://www.w3.org/1999/xlink"
            :width "20px"
            :height "20px"
            :viewBox "0 0 20 20"
            :version "1.1"}
           [:g
            {:id "surface1"}
            [:path
             {:style {:stroke "none" :fill-rule "nonzero" :fill "rgb(100%,100%,100%)" :fill-opacity "1"}
              :d "M 10 17.5 C 8.082031 17.5 6.414062 16.863281 4.988281 15.59375 C 3.566406 14.320312 2.75 12.734375 2.542969 10.832031 L 4.25 10.832031 C 4.445312 12.277344 5.085938 13.472656 6.175781 14.417969 C 7.269531 15.359375 8.542969 15.832031 10 15.832031 C 11.625 15.832031 13.003906 15.265625 14.136719 14.136719 C 15.269531 13.003906 15.832031 11.625 15.832031 10 C 15.832031 8.375 15.265625 6.996094 14.136719 5.863281 C 13.003906 4.730469 11.625 4.167969 10 4.167969 C 9.042969 4.167969 8.144531 4.390625 7.3125 4.832031 C 6.480469 5.277344 5.777344 5.890625 5.207031 6.667969 L 7.5 6.667969 L 7.5 8.332031 L 2.5 8.332031 L 2.5 3.332031 L 4.167969 3.332031 L 4.167969 5.292969 C 4.875 4.402344 5.738281 3.714844 6.761719 3.230469 C 7.78125 2.742188 8.863281 2.5 10 2.5 C 11.042969 2.5 12.015625 2.699219 12.925781 3.09375 C 13.835938 3.492188 14.628906 4.023438 15.300781 4.699219 C 15.976562 5.371094 16.511719 6.164062 16.90625 7.074219 C 17.304688 7.980469 17.5 8.957031 17.5 10 C 17.5 11.042969 17.300781 12.015625 16.90625 12.925781 C 16.507812 13.835938 15.976562 14.628906 15.300781 15.300781 C 14.628906 15.976562 13.835938 16.511719 12.925781 16.90625 C 12.019531 17.304688 11.042969 17.5 10 17.5 Z M 12.332031 13.5 L 9.167969 10.332031 L 9.167969 5.832031 L 10.832031 5.832031 L 10.832031 9.667969 L 13.5 12.332031 Z M 12.332031 13.5"}]]]])])))
























(defn raid-cache-id-reset-btn []
  (let [raidpurger (re-frame/subscribe [::subs/raidpurger])
        raidpurger-allowed (= @raidpurger "allowed")
        ts (re-frame/subscribe [::subs/raids-cache-id])
        d (new js/Date @ts)
        gmt-str (.toLocaleString d)]
    [:div {:style {:text-align "center"
                   :margin "10px 0 10px 0"}}
     "EID abbrev table: "
     [:div {:class "btn-group btn-group-sm"}
      [:span {:class "btn btn-default"
              :style {:cursor "auto"}}
       (if (not (nil? @ts)) (str "last reset: " gmt-str) "loading...")]
      (when (true? raidpurger-allowed)
        [:button {:class "btn btn-danger"
                  :on-click (fn [e]
                              (data/reset-raid-cache-id)
                              (data/reset-eid2raid)
                              (data/reset-raid2eid))} "Reset Now"])]]))




(defn pager [meta-sub]
  (let [query-params (re-frame/subscribe [::subs/query-params])
        meta (re-frame/subscribe [meta-sub])
        page (or (:page @query-params) 1)
        ;; limit (or (:n @query-params) 50)
        ;; q (:q @query-params)
        ]

    [:ul.pager
     (when (> (int page) 1)
       [:li.previous
        [:a
        ;;  {:href (str "?page=" (dec (int page))
        ;;              "&n=" limit
        ;;              (when (some? q) (str "&q=" q)))}
         {:href (str "?" (cemerick.url/map->query (conj @query-params {:page (dec (int page))})))}
         [:span.bi.bi-chevron-bar-left]
         " \n\t\t\tPrevious"]])
    ;; Note: added n_returned > 0 check to compensate for has_more not working properly (always true)
     (when (and (> (:n_returned @meta) 0) (:has_more @meta))
       [:li.next
        [:a
        ;;  {:href (str "?page=" (inc (int page))
        ;;              "&n=" limit
        ;;              (when (some? q) (str "&q=" q)))}
         {:href (str "?" (cemerick.url/map->query (conj @query-params {:page (inc (int page))})))}
         "\n\t\t\tNext\n\t\t\t"
         [:span.bi.bi-chevron-bar-right]]])]))



(defn bm-pager [meta-sub]
  (let [query-params (re-frame/subscribe [::subs/query-params])
        meta (re-frame/subscribe [meta-sub])
        nbm (:next_page_bookmark @meta)
        pbm (:prev_page_bookmark @meta)]
    [:ul.pager
    ;;  (when pbm
    ;;    [:li.previous
    ;;     [:a
    ;;      {:href (str "?" (cemerick.url/map->query (conj @query-params {:bm pbm})))}
    ;;      [:span.bi.bi-chevron-bar-left]
    ;;      " \n\t\t\tPrevious"]])
     (when nbm
       [:li.next
        [:a
         {:href (str "?" (cemerick.url/map->query (conj @query-params {:bm nbm})))}
         "\n\t\t\tNext\n\t\t\t"
         [:span.bi.bi-chevron-bar-right]]])]))



(defn copier
  ([title value] (copier title value value))
  ([title value label]
   (let [tip (reagent/atom false)]
     (fn []
       [:<>
        [:span
         {:style {:cursor "copy"}
          :id value
          :title title
          :on-click (fn [e] (do (reset! tip true)
                                (js/setTimeout #(reset! tip false) 1000)
                                (utils/copy-to-clipboard value)))}
         label]
        (when (true? @tip)
          [:span {:style {:position "absolute"
                          :top "-25px"
                          :left "0"
                          :padding "2px 5px 0px 5px"
                          :border "1px solid grey"
                          :background-color "orange"
                          :color "white"
                          :font-family "Menlo,Monaco,Consolas,Courier New,monospace"
                          :font-size "1.5rem"
                          :line-height "2rem"
                          :font-weight "bold"
                          :border-radius "4px"}} "COPIED!"])]))))


(defn set-raid-len [e raid-len]
  (.preventDefault e)
  (localstorage/set-item! "iris.post.raid-len" raid-len)
  (re-frame/dispatch [::events/set-raid-len raid-len]))

(defn raid-len-btns []
  (let [raid-len @(re-frame/subscribe [::subs/raid-len])
        inc-btn-css-class (if (>= raid-len globals/RAID_LEN_MAX) "disabled" "")
        dec-btn-css-class (if (<= raid-len globals/RAID_LEN_MIN) "disabled" "")]
    [:div.btn-group.btn-group-sm
     {:role "group"}
     [:a.btn.btn-primary {:title "Decrease raid size"
              :class dec-btn-css-class
              :style {:width "28px"}
              :on-click (fn [e] (set-raid-len e (- raid-len 1)))}
      "-"]
     [:span.btn.disabled {:title "table view"
                          :class "btn-default"}
      raid-len]
     [:a.btn.btn-primary {:title "Increase raid size"
              :class inc-btn-css-class
              :style {:width "28px"}
              :on-click (fn [e] (set-raid-len e (+ raid-len 1)))} "+"]]))



(defn settings []
  ;; button on active simple modal with content (eid shortener picker and fonts +-)
  (let [display (reagent/atom false)]
    (fn []
      [:<>
       [:button {:title "Settings"
                 :class
                ;;  (str "btn "
                ;;             ;;  (<class $settings/settings-btn)
                ;;              $settings/$settings-btn

                ;;              )
                 $settings/$settings-btn
                 :on-click (fn [e]
                             (println "click settings")
                             (reset! display (not @display)))}
        [:i {:class "glyphicon glyphicon-cog"}]]
       (when @display
         [simple-modal
          "Settings"
          [:div {:style {:color "#333"}}
           [:table {:style {:width "100%" :color "#333" :font-weight "bold"}}
            [:tr {:style {:height "45px"}}
             [:td {:style {:width "50%"}} "Raid string size: "]
             [:td {:style {:width "50%" :text-align "right"}} [raid-len-btns]]]
            [:tr {:style {:height "45px"}}
             [:td {:style {:width "50%"}} "Posts font size:"]
             [:td {:style {:width "50%" :text-align "right"}} [text-resizer]]]]
           [:hr {:style {:display "block" :margin "10px 0"}}]
           [:p {:style {:margin 0 :font-size "13px" :text-align "center"}} "Settings will be saved locally in your browser."]]
          300
          (fn [e]
            (.preventDefault e)
            (reset! display false))])])))


(defn search-help []
  (let [display (reagent/atom false)]
    (fn []
      [:<>
       [:span.searchhelpwrapns
        [:span.glyphicon.glyphicon-question-sign
         {:class
          ;; (<class $search/search-help-icon)
          $search/$search-help-icon
          :aria-hidden "true"
          :on-mouse-over (fn [e] (reset! display true))
          :on-mouse-out (fn [e] (reset! display false))}]]
       [:div {:class
              ;; (<class $search/search-help-div @display)
              ($search/$search-help-div @display)}
        [:h4 {:class
              ;; (<class $search/search-help-h4)
              $search/$search-help-h4}
         "Search field operator help:"]
        [:p
         "To search by the field please enter the corresponding field's \"operator:value\" into search box. For example: \"category:acme\"."]
        [:table.searchFields
         [:tbody
          [:tr
           [:td [:b "Field:"]]
           [:td {:height "10px"} [:b "Search Operator:"]]]
          [:tr
           [:td {:class
                 ;;  (<class $search/search-help-td)
                 $search/$search-help-td} "name1"]
           [:td {:class
                ;;  (<class $search/search-help-td)
                 $search/$search-help-td
                 } "value1"]]
          [:tr
           [:td {:class
                ;;  (<class $search/search-help-td)
                 $search/$search-help-td
                 } "name1"]
           [:td {:class
                ;;  (<class $search/search-help-td)
                 $search/$search-help-td
                 } "value1"]]]]]])))





(defn search []
  (let [index (reagent/atom "admin")
        order (reagent/atom "desc")
        q (reagent/atom "")
        ;; display (reagent/atom false)
        ]
    (fn []
      [:div.search
       [:div.searchwrapns {:class
                            ;; (<class $search/search-wrap)
                           $search/$search-wrap
                           }
        ;; [:span.glyphicon.glyphicon-search
        ;;  {:class (<class $search/search-icon)
        ;;   :on-click (fn [e] (reset! display (not @display)))}]
        [:div.searchbarns {:class
                           ;;  (<class $search/search-bar
                           ;;          ;; @display
                           ;;          true)
                           $search/$search-bar}
         [:form.form-inline.my-2.my-lg-0
          [:div {:class
                 ;;  (<class $search/input-wrap-dev)
                 $search/$input-wrap-dev}
           [:span.orderinputwrapspan
            {:class
             ;;  (<class $search/order-input-wrap-span)
             $search/$order-input-wrap-span}

            [:label
             {:class
              ;; (<class $search/input-label)
              $search/$input-label}
             [:input
              {:default-checked (= @index "admin")
               :on-change (fn [e] (reset! index "admin"))
               :value "admin"
               :name "index"
               :type "radio"}] "admin"]
            [:label
             {:class
              ;; (<class $search/input-label)
              $search/$input-label}
             [:input {:default-checked (= @index "public")
                      :on-change (fn [e] (reset! index "public"))
                      :value "public"
                      :name "index"
                      :type "radio"}] "public"]]
           [:span.indexinputwrapspanns
            {:class
             ;;  (<class $search/index-input-wrap-span)
             $search/$index-input-wrap-span}
            [:label
             {:class
              ;; (<class $search/input-label)
              $search/$input-label}
             [:input
              {:default-checked (= @order "desc")
               :on-change (fn [e] (reset! order "desc"))
               :value "desc"
               :name "order"
               :type "radio"}] "newest"]
            [:label
             {:class
              ;; (<class $search/input-label)
              $search/$input-label}
             [:input {:default-checked (= @order "asc")
                      :on-change (fn [e] (reset! order "asc"))
                      :value "asc"
                      :name "order"
                      :type "radio"}] "oldest"]]]
          [:input {:value "TLO" :type "hidden" :name "ws"}]
          [:input.form-control.mr-sm-2
           {:aria-label "Search"
            :placeholder "Search"
            :name "q"
            :type "search"
            :on-change (fn [e] (reset! q (-> e .-target .-value)))
            :style {:font-size "16px"}}]
          [:button.btn.btn-outline-success
           {:type "submit"
            :class
            ;; (<class $search/search-btn)
            $search/$search-btn
            :on-click (fn [e]
                        (.preventDefault e)
                        (let [qp {:index @index :order @order :ws "TLO" :q @q}
                              qp-str (str (routes/url-for :search) "?index=" @index "&order=" @order "&ws=TLO" "&q=" @q)]
                          (.pushState js/history qp "" qp-str)
                          (routes/dispatch {:handler :search :query-params qp}))
                        (re-frame/dispatch [::events/toggle-show-search-bar]))}
           "Search"]
          [search-help]]]]])))


(defn search-bar []
  (let [show-search-bar @(re-frame/subscribe [::subs/show-search-bar])]
    (when (true? show-search-bar)
      [search])))


(defn tier-data []
  [:span {:title (str "Tier (Data: " js/window.env ")")} js/window.tier])


(defn admin-top-bar-ws-btn [ws params]
  [:a
   {:style {:padding "3px 5px" :line-height 1}
    :target "_blank"
    :href (if (= (:ws params) ws)
            (str "https://" (str/lower-case ws) "."
                 (:domain params)
                 (when (contains? (:pathname-panels params) (:panel params))
                   (str/replace (:pathname params) (re-pattern (str "." (:ws params))) ""))
                 (when-let [anchor  (:anchor params)] (str "#" anchor)))
            (str "https://" (str/lower-case ws) "." (:domain params)))}
   ws])

(defn admin-top-bar-athena-btn [params]
  [:a
   {:style {:padding "3px 5px" :line-height 1}
    :target "_blank"
    :href (str "https://athena."
               (:domain params)
               (when (contains? (:pathname-panels params) (:panel params))
                 (:pathname params)))}
   "Athena"])

;; (defn admin-top-bar []
;;   ;; show pathname only for currently selected website and specific panels
;;   ;; TODO: question - how can "tiern" (number) be anything other than nil if we only have iris (dev, test, prod)??
;;   (let [tiern-domain (utils/get-tiern-domain)
;;         domain (:domain tiern-domain)
;;         ;; ws @(re-frame/subscribe [::posts-subs/ws])
;;         ws @(re-frame/subscribe [::subs/ws])
;;         pathname (.. js/window -location -pathname)
;;         anchor @(re-frame/subscribe [::subs/anchor-params])
;;         panel @(re-frame/subscribe [::subs/active-panel])
;;         ws-btn-params {:domain domain
;;                        :ws ws
;;                        :pathname pathname
;;                        :anchor anchor
;;                        :panel panel
;;                        :pathname-panels #{:thread-panel
;;                                           :posts-header-panel
;;                                           :hashtag-panel}}
;;         athena-btn-params {:domain domain
;;                            :pathname pathname
;;                            :panel panel
;;                            :pathname-panels #{:thread-panel
;;                                               :posts-header-panel
;;                                               :posts-ip-panel
;;                                               :posts-eid-panel
;;                                               :user-panel}}]
;;     [:div#admin-top-bar.bg-warning
;;      {:class (<class $search/admin-top-bar)}
;;      [:div#service-info.container-fluid
;;       {:class (<class $search/service-info)}
;;       [tier-data]
;;       [:span {:title "Version"}
;;        (if (exists? js/window.version) (str " " js/window.version) " v0.0.0")]
;;       [:span
;;        {:title
;;         "Instance ID:"}]
;;       [:span.glyphicon.glyphicon-search
;;        {:class (<class $search/search-icon)
;;         :on-click (fn [e]
;;                     ;; (reset! display (not @display))
;;                     (re-frame/dispatch [::events/toggle-show-search-bar]))}]]
;;      [:div#service-switch
;;       [:ul.nav.nav-tabs
;;        [:li
;;         [admin-top-bar-ws-btn "TLO" ws-btn-params]]
;;        [:li
;;         [admin-top-bar-ws-btn "TSC" ws-btn-params]]
;;        [:li
;;         [admin-top-bar-ws-btn "STK" ws-btn-params]]
;;        [:li.active
;;         [:a
;;          {:style {:padding "3px 5px" :line-height 1 :color "white" :background-color "navy"} :href "#"}
;;          "Iris"]]
;;        [:li
;;         [admin-top-bar-athena-btn athena-btn-params]]]]]))



(defn admin-top-bar []
  (let [route-params (re-frame/subscribe [::subs/route-params])
        query-params (re-frame/subscribe [::posts-subs/query-params])]
    (println "admin-top-bar route-params::" @route-params)
    (println "admin-top-bar query-params::" @query-params)
    [:rk-admin-top-bar {:active "iris"
                        :tier js/tier
                        :version js/version
                        :ws (:ws @query-params)
                        :xpaths (.stringify js/JSON (clj->js {:w3 "^(login|homepage|twbot|analytics|sessions|dev|search|screening|censoring|screens|censors|posts|latest|recent-activity|recent-posts|last-25|user/|cc/|ip/|eid/)",
                                                              :admin "^(login|homepage|twbot|analytics|sessions|dev|screening|censoring|screens|censors|latest|recent-activity|recent-posts|last-25)",
                                                              :athena "^(posts)"
                                                              :agor ".*"}))}
     [:span.glyphicon.glyphicon-search
      {:on-click (fn [e]
                   (re-frame/dispatch [::events/toggle-show-search-bar]))}]]))



(defn on-log-out [e]
  (.preventDefault e)
  (login-events/logout))


(defn logged-in-as []
  (fn []
    [:li [:a "Logged in as " @globals/fb-user]]))


(defn navbar
  ([] [navbar {}])
  ([options]
   [admin-top-bar]
   (let [toggle (reagent/atom false)
         viewport-size (re-frame/subscribe [::subs/viewport-size])
         roles (re-frame/subscribe [::subs/roles])
         tracker (re-frame/subscribe [::dev-subs/tracker])]
     (fn []
       [:nav#navbar.navbar.navbar-inverse
        {:role "navigation"
         :style {;;added to make navbar go over logs panel and search icon shows up
                ;;  :z-index 10000
                 }
         :class
          ;; (<class $search/navbar)
         $search/$navbar
         }
        [:div.container-fluid
         [:div.navbar-header
          [:button.navbar-toggle
           {:data-target "#nav-main",
            :data-toggle "collapse",
            :type "button"
            :on-click (fn [e]
                        (reset! toggle (not @toggle)))}
           [:span.sr-only "Toggle navigation"]
           [:span.icon-bar]
           [:span.icon-bar]
           [:span.icon-bar]]
          (when (and (not (nil? (:x @viewport-size))) (< (:x @viewport-size) 768))
            [:<>
             ;;  [thread-alert]
             [settings]
             [thread-alert]])
          [:div#thread-alert-mobile]
          [:a.navbar-brand {:href "/"} [:i.glyphicon.glyphicon-home]]]
         [:div#nav-main.collapse.navbar-collapse {:class (when (true? @toggle) "in")}
          [:ul.nav.navbar-nav
           [:li
            [:a {:href "/posts"} [:i.glyphicon.glyphicon-list] " Posts"]]
           [:li
            [:a
             {:title "Search posts", :href "/search"}
             [:i.glyphicon.glyphicon-search]
             " Search"]]
           [:li
            [:a
             {:href "/last-25.php"}
             [:i.glyphicon.glyphicon-time]
             " Last25"]]
           [:li
            [:a
             {:href "/censoring"}
             [:i.glyphicon.glyphicon-erase]
             " Censor"]]
           [:li
            [:a
             {:href "/screening"}
             [:i.glyphicon.glyphicon-tower]
             " Screen"]]
           (when (contains? @roles "developer")
             [:li
              [:a
               {:href "/tags"}
               [:i.glyphicon.glyphicon-tags]
               " Tags"]])
           [:li
            [:a
             {:href "/analytics"}
             [:i.glyphicon.glyphicon-stats]
             " Analytics"]]

           (when (contains? @roles "tester")
             [:li (when (true? @tracker) {:class "recording-bg-anim"})
              [:a
               {:href "/dev"}
               [:i.glyphicon.glyphicon-wrench]
               " Dev"]])]

          [:div#logininfo
           [:ul#nav-users.nav.navbar-nav.navbar-right
            {:style {:position "relative"}}

            (when (and (not (nil? (:x @viewport-size))) (>= (:x @viewport-size) 768))
              [:<>
               [:li {:style {:position "initial"}}
                [thread-alert]]
               [:li
                [settings]]
               ;;  [:li {:style {:position "initial"}}
               ;;   [thread-alert]]
               ])
            ;; (when (and (not (nil? (:x @viewport-size))) (>= (:x @viewport-size) 1024))
            ;; [logged-in-as]
            ;; )
            ;; [:li
            ;;  [:a
            ;;   {:on-click (fn [e] (on-log-out e))
            ;;    :style {:cursor "pointer"}}
            ;;   [:i.glyphicon.glyphicon-log-out]
            ;;   " Log out"]]
            ]]]]
        [search-bar]]))))




;; (defn set-raid-len [e raid-len]
;;   (.preventDefault e)
;;   (re-frame/dispatch [::events/set-raid-len raid-len]))

;; (defn raid-len-btns []
;;   (let [raid-len @(re-frame/subscribe [::subs/raid-len])
;;         inc-btn-css-class (if (>= raid-len globals/RAID_LEN_MAX) "btn-success disabled" "btn-success")
;;         dec-btn-css-class (if (<= raid-len globals/RAID_LEN_MIN) "btn-danger disabled" "btn-danger")]
;;     [:div.btn-group.btn-group-sm
;;      {:role "group"}
;;      [:a.btn {:title "list view"
;;               :class inc-btn-css-class
;;               :on-click (fn [e] (set-raid-len e (+ raid-len 1)))} "+"]
;;      [:span.btn.disabled {:title "table view"
;;                           :class "btn-default"}
;;       raid-len]
;;      [:a.btn {:title "table 2 view"
;;               :class dec-btn-css-class
;;               :on-click (fn [e] (set-raid-len e (- raid-len 1)))}
;;       "-"]]))